/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Description/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Description({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Procedures/AddAction/Add/Content/Description",
  onChange,
  isInvalid
  
}) {
let procedureDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'procedure',
path: 'description',
})
let procedureDescriptionIsValidData = fromData.useDataIsValid({ viewPath,
context: 'procedure',
path: 'description',
validate: fromValidate.textInput,
required: true,
})
let procedureDescriptionChangeData = fromData.useDataChange({ viewPath,
context: 'procedure',
path: 'description',
})
  return (<React.Fragment
>
<div
  data-testid="Description.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="procedure.description"
 value={procedureDescriptionValueData}
 onChange={procedureDescriptionChangeData}
 validate="/Data/validate.js textInput"
 required={true}
 invalid={!procedureDescriptionIsValidData}
 marginTop={0}
 type="text"
 placeholder="Procedure description"
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Description"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
</div>
{children}
</React.Fragment>)
}